import {SvgIcon, SvgIconProps} from '@mui/material';
import React from 'react';
// @ts-ignore
import {ReactComponent as arrow_left_middle} from '../../assets/arrow_left_middle.svg';

const ArrowLeftMiddle: React.FC<SvgIconProps> = (props) => {
  return (
    <SvgIcon {...props} component={arrow_left_middle} viewBox='0 0 106 91' />
  );
};

export default ArrowLeftMiddle;
